import {Store,Module,ActionContext} from 'vuex'
import Ajax from '../../lib/ajax';

class CommonModule {
    namespaced=true;
    state ={
        paymethodsDic: {},
        paymethods: [],
        orderTypes: [],
        orderTypesDic: {},
        verifyStateList: [],
        verifyStateListDic: {},
        orderStatesDic: {},
        orderStates: [],
        offerDateTypeDic: {},
        holidayTypes: [],
        holidayTypeDic: {},
        headTypes:[]
    };
    
    actions = {
        async getMethods(context: any,payload: any)
        {
            let reponse=await Ajax.get('/api/services/app/Common/GetPaymethodDic');
            context.state.paymethodsDic = reponse.data.result;
            let rep=await Ajax.get('/api/services/app/Common/GetOfferPayMethod');
            context.state.paymethods = rep.data.result;
        },
        async getOrderTypes(context: any, payload: any){
            let reponse=await Ajax.get('/api/services/app/Common/GetLabelValueOrderType');
            context.state.orderTypes = reponse.data.result;
            let rep=await Ajax.get('/api/services/app/Common/GetOrderTypeDic');
            context.state.orderTypesDic = rep.data.result;
        },
        async getVerifyStateList(context: any, payload: any)
        {
            let rep=await Ajax.get('/api/services/app/Common/GetLabelValueVerifyState');
            context.state.verifyStateList = rep.data.result;
            let rep2=await Ajax.get('/api/services/app/Common/GetLabelValueVerifyStateDic');
            context.state.verifyStateListDic = rep2.data.result;
        },
        async getOrderStates(context: any, payload: any)
        {
            let rep=await Ajax.get('/api/services/app/Common/GetLabelValueOrderState');

            context.state.orderStates = rep.data.result;
           // context.state.headTypes.copy(rep.data.result);
           //  let newArr = []
            context.state.headTypes=JSON.parse(JSON.stringify(rep.data.result))
          context.state.headTypes.unshift({
                label:'全部订单',
                value:null,
                latitude:0,
                longitude:0
            })
            let reponse=await Ajax.get('/api/services/app/Common/GetOrderStateDic');
            context.state.orderStatesDic = reponse.data.result;
        },
        async getOfferDateTypeDic(context: any, payload: any) {
            let reponse=await Ajax.get('/api/services/app/OfferDateType/GetDateTypeDic');
            context.state.offerDateTypeDic = reponse.data.result;
        },
        async getHolidayTypes(context: any, payload: any){
            let reponse=await Ajax.get('/api/services/app/Common/GetLabelValueHolidayType');
            context.state.holidayTypes = reponse.data.result;
            let rep=await Ajax.get('/api/services/app/Common/GetHolidayTypeDic');
            context.state.holidayTypeDic = rep.data.result;
        },
        async init(context: any, payload: any) {
            await context.dispatch('common/getOfferDateTypeDic',null,{root:true});
            await context.dispatch('common/getOrderStates',null,{root:true});
            await context.dispatch('common/getVerifyStateList',null,{root:true});
            await context.dispatch('common/getOrderTypes',null,{root:true});
            await context.dispatch('common/getMethods',null,{root:true});
            await context.dispatch('common/getHolidayTypes',null,{root:true});
        }
    }
}

const commonModule = new CommonModule();
export default commonModule;